import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/dmitry.petrov/Workspace/dxfeed-js-api/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h1>
    <p>{`This package provides access to `}<a parentName="p" {...{
        "href": "https://www.dxfeed.com/"
      }}>{`dxFeed`}</a>{` streaming data.`}</p>
    <p>{`Our package is easy to integrate with any modern framework.`}</p>
    <p>{`On this website, you will find usage examples.`}</p>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <p>{`Install package from NPM`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm install @dxfeed/api
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      